export const products = [
    {
      id: 1,
      img: "https://www.linkpicture.com/q/LPic626e4acaba758896644665.jpg",
      link: "https://filmsrecommendationsystem.herokuapp.com/",
    },
    {
      id: 2,
      img: "https://wallpapercave.com/wp/wp9622280.jpg",
      link: "https://share.streamlit.io/19bcs4325-hardik/crop_prediction/app.py",
    },
    {
      id: 3,
      img: "https://wallpapercave.com/dwp1x/wp10487444.gif",
      link: "https://github.com/19BCS4325-Hardik/state_quiz_India",
    },
    {
      id: 4,
      img: "https://wallpapercave.com/dwp1x/wp2506454.jpg",
      link: "https://share.streamlit.io/19bcs4325-hardik/ipl_matchwinner_predictor/app.py",
    },
    {
      id: 5,
      img: "https://wallpapercave.com/dwp1x/wp6090719.jpg",
      link: "https://19bcs4325-hardik.github.io/Turbofy/",
    },
    {
      id: 6,
      img: "https://wallpapercave.com/dwp1x/wp10456030.jpg",
      link: "https://19bcs4325-hardik.github.io/Digital_Agency/",
    },
  ];